// @flow
import getCSSHexColor from './getCSSHexColor';
import getHexColorComponents from './getHexColorComponents';

/**
 * Darkens a CSS color by the amount given. The `darkenByAmount` value is a scale from 0 to 1 where
 * 0 means "don't darken at all" (which returns the same color) and 1 means "darken completely"
 * (which means return black.)
 *
 * @param hexColor - A 6-digit CSS hex color
 * @param darkenByAmount - A number between 0 and 1 indicating how much to darken by
 * @return A 6-digit CSS hex color darken by the requested amount
 */
const darken = (hexColor: string, darkenByAmount: number): string => {
  const { red, green, blue } = getHexColorComponents(hexColor);
  const newRed = red - Math.round(red * darkenByAmount);
  const newGreen = green - Math.round(green * darkenByAmount);
  const newBlue = blue - Math.round(blue * darkenByAmount);
  return getCSSHexColor(newRed, newGreen, newBlue);
};

export default darken;
